import styled from "styled-components";

export const StyledOpenBankingFailedStep = styled.div`
	max-width: 63rem;
`;